import type { RunParams } from "./types";

export const defaultRunParams: RunParams = {
  use_fingerprint: true,
  sync_to_feishu: true,
  proxy_speed_test_enabled: true,
  same_profile_cache_warmup_enabled: true,
  force_new_proxy: false,
  proxy_retry_count: 3,
  proxy_params: {}
};

export function normalizeRunParams(value: unknown): RunParams {
  const source = value && typeof value === "object" ? (value as Partial<RunParams>) : {};
  return {
    ...defaultRunParams,
    ...source,
    proxy_retry_count: Number(source.proxy_retry_count || defaultRunParams.proxy_retry_count),
    proxy_params: source.proxy_params && typeof source.proxy_params === "object" ? (source.proxy_params as Record<string, unknown>) : {}
  };
}

export function runParamsFromConfig(config: Record<string, unknown>): RunParams {
  return normalizeRunParams(config.default_run_params);
}
